import { Box, Typography, List, ListItem } from "@mui/material";
import ProductItemCard from "./ItemCard";

interface Product {
  id: string;
  full_name: string;
  dni: string;
  status_id: number;
}


interface ProductsListProps {
  products: Product[];
  selectedProduct: Product | null;
  onSelect: (product: Product) => void;
  onRefresh: () => Promise<void>;
}

export default function ProductsList({
  products,
  selectedProduct,
  onSelect,
  onRefresh,
}: ProductsListProps) {
  return (
    <List sx={{ maxHeight: "67vh", overflowY: "auto", pb: 4 }}>
      {products.map((u) => (
        <ListItem
          key={u.id}
          disableGutters
          onClick={() => onSelect(u)}
          sx={{
            px: 2,
            py: 1.5,
            borderBottom: "1px solid #f5f5f5",
            cursor: "pointer",
            backgroundColor:
              selectedProduct?.id === u.id ? "#fafafa" : "transparent",
            "&:hover": { backgroundColor: "#fafafa" },
          }}
        >
          <ProductItemCard
            product={u}
            showButton={false}
            onStatusChange={onRefresh}
          />


        </ListItem>
      ))}

      {products.length === 0 && (
        <Typography
          sx={{
            color: "#999",
            fontSize: 14,
            textAlign: "center",
            py: 3,
          }}
        >
          No se encontraron motorizados.
        </Typography>
      )}
    </List>
  );
}
